"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createWebNetworkClient = exports.iterableFromReadable = void 0;
const micro_streaming = __importStar(require("@journeyapps-platform/micro-streaming"));
const streaming = __importStar(require("../streaming"));
const requester = __importStar(require("./request"));
const utils = __importStar(require("../utils"));
async function* iterableFromReadable(readable) {
    const reader = readable.getReader();
    try {
        while (true) {
            const { done, value } = await reader.read();
            if (done) {
                return;
            }
            yield value;
        }
    }
    finally {
        reader.releaseLock();
    }
}
exports.iterableFromReadable = iterableFromReadable;
const createWebNetworkClient = (options) => {
    return {
        augment: (augmented) => {
            return (0, exports.createWebNetworkClient)({ ...augmented, ...options });
        },
        request: async (url, params) => {
            let headers = {};
            let body;
            if (params.body) {
                if (streaming.isStreamedPayload(params.body)) {
                    if (options?.buffer_streams ?? true) {
                        body = Buffer.concat(await micro_streaming.drain(streaming.ensureIterable(params.body.encode())));
                    }
                    else {
                        body = new streaming.RawStream(micro_streaming.readableFrom(params.body.encode()));
                    }
                    headers = streaming.headersForStream(params.body);
                }
                else {
                    body = params.body;
                }
            }
            return requester.request(url, {
                ...(options || {}),
                ...params,
                headers: utils.constructHeaders([headers, params.headers, options?.headers]),
                user_agent: options?.user_agent,
                body: body,
                request: async (url, params) => {
                    return await fetch(url, params);
                }
            });
        }
    };
};
exports.createWebNetworkClient = createWebNetworkClient;
